import Rollbar from 'rollbar';

import {LogLevel} from '../consts';
import {Transport} from './Transport';

export class RollbarTransport extends Transport {
  private instance: Rollbar;

  constructor({
    instance,
    level = 'debug',
  }: {instance: Rollbar; level?: LogLevel}) {
    super({level});

    this.instance = instance;
  }

  getTitle(name: string): string {
    return name ? `[${name}]` : '';
  }

  log(name: string, level: LogLevel, message: string, ...args: unknown[]) {
    const levelsFallback = {
      critical: this.instance.critical,
      error: this.instance.error,
      warn: this.instance.warn,
      info: this.instance.info,
      verbose: this.instance.log,
      debug: this.instance.debug,
    };

    const title = this.getTitle(name);
    if (title) {
      message = `${title} ${message}`;
    }
    const handler = levelsFallback[level];
    handler.bind(this.instance)(message, {...args});
  }
}
